export default __webpack_public_path__ + "static/logo-dumpster-1e93165bee58601fd9f9bb9f890af7b8.png";